import plotDetailChildren from '@/router/modules/productManage/PlotDetail/plotDetailChildren'

export default {
  path: 'plot-detail',
  name: 'PlotDetail',
  meta: {
    title: '地块详情',
    show: false
  },
  props: route => ({ landId: Number(route.query.landId) }),
  redirect: {
    name: 'CropBreedList'
  },
  component: () => import('@/views/productManage/PlotDetail'),
  children: plotDetailChildren
}
